exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WVbiB{font-size:12px;width:125px;min-width:125px!important}", ""]);

// exports
exports.locals = {
	"select": "WVbiB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/containers/share-overlay/embed-form/embed-select/embed-styles.styl
// module id = 1423
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact